module.exports = __webpack_public_path__ + "static/media/9_zemly_0_90.56.d6125f5a.png";